module.exports = __webpack_public_path__ + "assets/img/home.b396b5bb.svg";